import './menus.css';
import { useNavigate } from "react-router-dom";
import { Accordion, Nav } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

function T8_logistics({setactivity, permission, manufacturing, activeItem}) {
  const navigate = useNavigate();
  const activeStyles = { fontWeight: 600, backgroundColor: '#e7f1ff', color: '#0d6efd' };
  return (
    (
      <Accordion.Item eventKey="1">
        <Accordion.Header>
          <span role="img" aria-label="logistics">🚚</span> Operaciones
        </Accordion.Header>
        <Accordion.Body className="p-0">
          <Nav className="flex-column">
            {permission === '1' && (
              <Nav.Link active={activeItem === 'despachos'} style={activeItem === 'despachos' ? activeStyles : undefined} onClick={() => navigate('/Despachos')}>Despachos</Nav.Link>
            )}
            {manufacturing && manufacturing !== '0' && (
              <Nav.Link active={activeItem === 'produccion'} style={activeItem === 'produccion' ? activeStyles : undefined} onClick={() => navigate('/Produccion')}>Producción</Nav.Link>
            )}
            {manufacturing && manufacturing !== '0' && (
              <Nav.Link active={activeItem === 'nfc_writer'} style={activeItem === 'nfc_writer' ? activeStyles : undefined} onClick={() => navigate('/NfcWriter')}>NFC Writer</Nav.Link>
            )}
          </Nav>
        </Accordion.Body>
      </Accordion.Item>
    )
  );
}

export default T8_logistics;
